import { useNavigate } from 'react-router-dom';
import { Footer } from '../First';

export function Backend() {
  const navigate = useNavigate();

  const buttons = [
    { label: 'Programming Languages', path: '/Pro_languages' },
    { label: 'Data Base', path: '/dbms' },
    { label: 'Frameworks', path: '/Frames' },
    { label: 'API', path: '/Api' },
    { label: 'Git & GitHub', path: '/Github' },
  ];

  return (
    <>
      <div className="front_container">
        <div className="front_contain">
          <h2 className="fr_1">Back End Development</h2>
          <p className="fr_2">
            All the resources are available through the links only kindly refer to this. We are providing the recommended
            platform not for any other promotions.
          </p>
          <p className="fr_rating">4.4 &#9733; &#9733; &#9733; &#9733;</p>
          <p>
            Created by{' '}
            <a
              href="https://www.linkedin.com/in/sayednowshad/"
              style={{ textDecoration: 'underline', fontSize: '17px', fontFamily: 'sans-serif' }}
            >
              SayedNowshad
            </a>
          </p>
        </div>
      </div>

      <h2 className="fr_des">Description</h2>
      <ul className="fr_list">
        <li className="fr_li">Click the below topics for more concepts to Unlock &#x1F512;</li>
        <li className="fr_li">See the topic-wise and select the topic.</li>
        <li className="fr_li">
          We provide all the facilities for searching and finding the best resources. Share this with your friends and
          spread it out.
        </li>
        <li className="fr_li">
          Thanks & Enjoy <strong>"Stay Hard &#x1F4AA;, Stay Consistently"</strong>
        </li>
      </ul>

      <h3 className="fr_cont">Content</h3>
      <div className="fr_butt">
        {buttons.map(({ label, path }) => (
          <button key={path} className="fr_butt_click" onClick={() => navigate(path)}>
            {label}
          </button>
        ))}
      </div>

      <Footer />
    </>
  );
}

export default Backend;
